/**
 * @param json {string}
 * @return {unknown}
 */
module.exports = function parseJson(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return null;
    }
}
